<template>

  <ul class="pagination" style="margin: 0">
    <li class="page-item" :class="{'active': page.active}" v-for="page in pageNav">
      <a class="page-link" href="javascript:void(0)" @click="changePage(page.pageNum)">
      
        <span v-show="!isNaN(page.keySymbol) || page.keySymbol === '...'">{{ page.keySymbol }}</span>
        <span v-show="page.keySymbol === '>'"> &raquo; </span>
        <span v-show="page.keySymbol === '<'"> &laquo; </span>
        <span v-show="page.keySymbol === '>|'"> &raquo;&raquo; </span>
        <span v-show="page.keySymbol === '|<'"> &laquo;&laquo; </span>

      </a>
    </li>
  </ul>

</template>

<script>
export default {
  name: 'Pagination',
  props: [
    'totalPages',
    'currentPage'
  ],
  data () {
    return {
      pageNav: [],
      pagesPerSegment: 5
    }
  },
  watch: {
    totalPages: function () {
      this.paginate()
    },
    currentPage: function () {
      this.paginate()
    }
  },
  created () {
    this.paginate()
  },
  methods: {
    paginate () {
      var pages = []
      var totalSegments = Math.floor((this.totalPages - 1) / this.pagesPerSegment) + 1

      if (this.currentPage < 1 || this.currentPage > this.totalPages) {
        // this.changePage(1)
      }

      var currentSegment = Math.floor((this.currentPage - 1) / this.pagesPerSegment) + 1
      var endPage = (currentSegment * this.pagesPerSegment) > this.totalPages
      ? this.totalPages
      : (currentSegment * this.pagesPerSegment)

      var startPage = (this.pagesPerSegment > endPage)
      ? 1
      : endPage - (this.pagesPerSegment - 1)

      if (currentSegment > 1) {
        pages.push({
          keySymbol: '|<',
          pageNum: 1,
          active: false
        })
        pages.push({
          keySymbol: '<',
          pageNum: this.currentPage - 1,
          active: false
        })
        pages.push({
          keySymbol: '...',
          pageNum: startPage - 1,
          active: false
        })
      }

      for (var p = startPage; p <= endPage; p++) {
        pages.push({
          keySymbol: '' + p,
          pageNum: p,
          active: p === this.currentPage
        })
      }

      if (currentSegment < totalSegments) {
        pages.push({
          keySymbol: '...',
          pageNum: endPage + 1,
          active: false
        })
        pages.push({
          keySymbol: '>',
          pageNum: parseInt(this.currentPage) + 1,
          active: false
        })
        pages.push({
          keySymbol: '>|',
          pageNum: this.totalPages,
          active: false
        })
      }

      this.pageNav = pages
    },
    changePage (page) {
      this.$emit('changePage', page)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Parts/Pagination.vue